import { combineReducers } from 'redux'
import { all } from 'redux-saga/effects'
import { StateType } from 'typesafe-actions'

import {
  SIMPLE_ACCOUNT,
  simpleAccountReducer,
  simpleAccountSaga,
} from '@/modules/account/SimpleAccountModule'
import {
  BILL_PAYMENT_AMOUNT,
  billPaymentAmountReducer,
  billPaymentAmountSaga,
} from '@/modules/bill-payment/BillPaymentAmountModule'
import {
  BILL_PAYMENT_MAIN,
  billPaymentMainReducer,
  billPaymentMainSaga,
} from '@/modules/bill-payment/BillPaymentMainModule'
import {
  BILL_PAYMENT_PRODUCT_GROUP,
  billPaymentProductGroupReducer,
  billPaymentProductGroupSaga,
} from '@/modules/bill-payment/BillPaymentProductGroupModule'
import {
  BILL_PAYMENT_PRODUCT,
  billPaymentProductReducer,
  billPaymentProductSaga,
} from '@/modules/bill-payment/BillPaymentProductModule'
import {
  BILL_PAYMENT_RESULT,
  billPaymentResultReducer,
  billPaymentResultSaga,
} from '@/modules/bill-payment/BillPaymentResultModule'
import { APP, appReducer, appSaga } from '@/modules/common/app'
import { ERROR, errorReducer } from '@/modules/common/error'
import { HISTORY, historyReducer, historySaga } from '@/modules/common/history'
import { LAYER, layerReducer } from '@/modules/common/layer'
import { LOADING, loadingReducer } from '@/modules/common/loading'
import { VERSION, versionReducer } from '@/modules/common/version'
import {
  DEBIT_CARD_ACTIVATE,
  debitCardActivateReducer,
  debitCardActivateSaga,
} from '@/modules/debit-card/DebitCardActivateModule'
import {
  DEBIT_CARD_DELETE,
  debitCardDeleteReducer,
  debitCardDeleteSaga,
} from '@/modules/debit-card/DebitCardDeleteModule'
import {
  DEBIT_CARD_DETAIL,
  debitCardDetailReducer,
  debitCardDetailSaga,
} from '@/modules/debit-card/DebitCardDetailModule'
import {
  DEBIT_CARD_HISTORY_DETAIL,
  debitCardHistoryDetailReducer,
  debitCardHistoryDetailSaga,
} from '@/modules/debit-card/DebitCardHistoryDetailModule'
import {
  DEBIT_CARD_HISTORY,
  debitCardHistoryReducer,
  debitCardHistorySaga,
} from '@/modules/debit-card/DebitCardHistoryModule'
import {
  DEBIT_CARD_ISSUE_DESIGN,
  debitCardIssueDesignReducer,
  // debitCardCommonListSaga,
} from '@/modules/debit-card/DebitCardIssueDesignModule'
import {
  DEBIT_CARD_ISSUE,
  debitCardIssueReducer,
  debitCardIssueSaga,
} from '@/modules/debit-card/DebitCardIssueModule'
import {
  DEBIT_CARD_ISSUE_SHIPPING,
  debitCardIssueShippingReducer,
  debitCardIssueShippingSaga,
} from '@/modules/debit-card/DebitCardIssueShippingModule'
import {
  DEBIT_CARD_LIST,
  debitCardListReducer,
  debitCardListSaga,
} from '@/modules/debit-card/DebitCardListModule'
import { SELECT_CARD, selectCardReducer } from '@/modules/debit-card/DebitCardSelectCardModule'
import { NOTICE, noticeReducer, noticeSaga } from '@/modules/notice/NoticeModule'
import {
  NOTIFICATION,
  notificationReducer,
  notificationSaga,
} from '@/modules/notification/NotificationModule'
import { PROFILE, profileReducer, profileSaga } from '@/modules/profile/ProfileModule'
/* TODO: remove referral-promotion */
import { INVITE, inviteReducer, inviteSaga } from '@/modules/promotion/InviteModule'
import { MGM, mgmReducer, mgmSaga } from '@/modules/promotion/MgmCodeModule'
import {
  SCHEDULE_PAYMENT_DETAIL,
  schedulePaymentDetailReducer,
  schedulePaymentDetailSaga,
} from '@/modules/schedule-payment/SchedulePaymentDetailModule'
import {
  SCHEDULE_PAYMENT_HISTORY_DETAIL,
  schedulePaymentHistoryDetailReducer,
  schedulePaymentHistoryDetailSaga,
} from '@/modules/schedule-payment/SchedulePaymentHistoryDetailModule'
import {
  SCHEDULE_PAYMENT_HISTORY,
  schedulePaymentHistoryReducer,
  schedulePaymentHistorySaga,
} from '@/modules/schedule-payment/SchedulePaymentHistoryModule'
import {
  SCHEDULE_PAYMENT,
  schedulePaymentReducer,
  schedulePaymentSaga,
} from '@/modules/schedule-payment/SchedulePaymentModule'
import {
  SCHEDULE_PAYMENT_REGISTER,
  schedulePaymentRegisterReducer,
  schedulePaymentRegisterSaga,
} from '@/modules/schedule-payment/SchedulePaymentRegisterModule'
import {
  SCHEDULEPAYMENT_READONLY,
  schedulePaymentReadOnlyReducer,
} from '@/modules/schedule-payment/SchedulePaymentScrollOffModule'
import {
  SCHEDULE_PAYMENT_SEND,
  schedulePaymentSendReducer,
  schedulePaymentSendSaga,
} from '@/modules/schedule-payment/SchedulePaymentSendModule'
import { SUPPORT, supportReducer, supportSaga } from '@/modules/support/SupportModule'
import {
  BILL_PAYMENT_AMOUNT as BILL_PAYMENT_AMOUNT_BETA,
  billPaymentAmountReducer as billPaymentAmountReducer_BETA,
  billPaymentAmountSaga as billPaymentAmountSaga_BETA,
} from '@/modules/version/V2/bill-payment/BillPaymentAmountModule'
import {
  BILL_PAYMENT_MAIN as BILL_PAYMENT_MAIN_BETA,
  billPaymentMainReducer as billPaymentMainReducer_BETA,
  billPaymentMainSaga as billPaymentMainSaga_BETA,
} from '@/modules/version/V2/bill-payment/BillPaymentMainModule'
import {
  BILL_PAYMENT_PRODUCT_GROUP as BILL_PAYMENT_PRODUCT_GROUP_BETA,
  billPaymentProductGroupReducer as billPaymentProductGroupReducer_BETA,
  billPaymentProductGroupSaga as billPaymentProductGroupSaga_BETA,
} from '@/modules/version/V2/bill-payment/BillPaymentProductGroupModule'
import {
  BILL_PAYMENT_PRODUCT as BILL_PAYMENT_PRODUCT_BETA,
  billPaymentProductReducer as billPaymentProductReducer_BETA,
  billPaymentProductSaga as billPaymentProductSaga_BETA,
} from '@/modules/version/V2/bill-payment/BillPaymentProductModule'
import {
  BILL_PAYMENT_RESULT as BILL_PAYMENT_RESULT_BETA,
  billPaymentResultReducer as billPaymentResultReducer_BETA,
  billPaymentResultSaga as billPaymentResultSaga_BETA,
} from '@/modules/version/V2/bill-payment/BillPaymentResultModule'

import {
  BILLPAYMENT_ALERT_LAYER,
  billpaymentAlertLayerReducer,
} from './version/V2/bill-payment/BillPaymentAlertLayerModule'

export const rootReducer = combineReducers({
  [APP]: appReducer,
  [LOADING]: loadingReducer,
  [LAYER]: layerReducer,
  [ERROR]: errorReducer,
  [HISTORY]: historyReducer,
  [VERSION]: versionReducer,

  [SIMPLE_ACCOUNT]: simpleAccountReducer,
  [PROFILE]: profileReducer,

  [SCHEDULE_PAYMENT]: schedulePaymentReducer,
  [SCHEDULE_PAYMENT_DETAIL]: schedulePaymentDetailReducer,
  [SCHEDULE_PAYMENT_HISTORY]: schedulePaymentHistoryReducer,
  [SCHEDULE_PAYMENT_HISTORY_DETAIL]: schedulePaymentHistoryDetailReducer,
  [SCHEDULE_PAYMENT_SEND]: schedulePaymentSendReducer,
  [SCHEDULE_PAYMENT_REGISTER]: schedulePaymentRegisterReducer,
  [SCHEDULEPAYMENT_READONLY]: schedulePaymentReadOnlyReducer,

  [DEBIT_CARD_ISSUE]: debitCardIssueReducer,
  [DEBIT_CARD_ISSUE_DESIGN]: debitCardIssueDesignReducer,
  [DEBIT_CARD_ISSUE_SHIPPING]: debitCardIssueShippingReducer,
  [DEBIT_CARD_ACTIVATE]: debitCardActivateReducer,
  [DEBIT_CARD_LIST]: debitCardListReducer,
  [DEBIT_CARD_HISTORY]: debitCardHistoryReducer,
  [DEBIT_CARD_HISTORY_DETAIL]: debitCardHistoryDetailReducer,
  [DEBIT_CARD_DELETE]: debitCardDeleteReducer,
  [DEBIT_CARD_DETAIL]: debitCardDetailReducer,
  [SELECT_CARD]: selectCardReducer,

  [BILL_PAYMENT_MAIN]: billPaymentMainReducer,
  [BILL_PAYMENT_AMOUNT]: billPaymentAmountReducer,
  [BILL_PAYMENT_RESULT]: billPaymentResultReducer,
  [BILL_PAYMENT_PRODUCT]: billPaymentProductReducer,
  [BILL_PAYMENT_PRODUCT_GROUP]: billPaymentProductGroupReducer,

  // payment V2
  [BILL_PAYMENT_MAIN_BETA]: billPaymentMainReducer_BETA,
  [BILL_PAYMENT_AMOUNT_BETA]: billPaymentAmountReducer_BETA,
  [BILL_PAYMENT_RESULT_BETA]: billPaymentResultReducer_BETA,
  [BILL_PAYMENT_PRODUCT_BETA]: billPaymentProductReducer_BETA,
  [BILL_PAYMENT_PRODUCT_GROUP_BETA]: billPaymentProductGroupReducer_BETA,
  [BILLPAYMENT_ALERT_LAYER]: billpaymentAlertLayerReducer,

  [SUPPORT]: supportReducer,
  [NOTICE]: noticeReducer,

  [NOTIFICATION]: notificationReducer,

  [INVITE]: inviteReducer,
  [MGM]: mgmReducer,
})

export function* rootSaga() {
  yield all([
    ...appSaga,
    ...historySaga,
    ...simpleAccountSaga,

    ...schedulePaymentSaga,
    ...schedulePaymentDetailSaga,
    ...schedulePaymentHistorySaga,
    ...schedulePaymentHistoryDetailSaga,
    ...schedulePaymentSendSaga,
    ...schedulePaymentRegisterSaga,

    ...debitCardListSaga,
    ...debitCardActivateSaga,
    ...debitCardHistorySaga,
    ...debitCardHistoryDetailSaga,
    ...debitCardDetailSaga,
    // ...debitCardCommonListSaga,
    ...debitCardIssueSaga,
    ...debitCardIssueShippingSaga,
    ...debitCardDeleteSaga,

    ...profileSaga,

    ...billPaymentMainSaga,
    ...billPaymentAmountSaga,
    ...billPaymentResultSaga,
    ...billPaymentProductGroupSaga,
    ...billPaymentProductSaga,

    ...notificationSaga,
    ...supportSaga,
    ...noticeSaga,

    ...inviteSaga,
    ...mgmSaga,
  ])
}

export function* rootSagaBeta() {
  yield all([
    ...appSaga,
    ...historySaga,
    ...simpleAccountSaga,

    ...schedulePaymentSaga,
    ...schedulePaymentDetailSaga,
    ...schedulePaymentHistorySaga,
    ...schedulePaymentHistoryDetailSaga,
    ...schedulePaymentSendSaga,
    ...schedulePaymentRegisterSaga,

    ...debitCardListSaga,
    ...debitCardActivateSaga,
    ...debitCardHistorySaga,
    ...debitCardHistoryDetailSaga,
    ...debitCardDetailSaga,
    // ...debitCardCommonListSaga,
    ...debitCardIssueSaga,
    ...debitCardIssueShippingSaga,
    ...debitCardDeleteSaga,

    ...profileSaga,

    // payment V2
    ...billPaymentMainSaga_BETA,
    ...billPaymentAmountSaga_BETA,
    ...billPaymentResultSaga_BETA,
    ...billPaymentProductGroupSaga_BETA,
    ...billPaymentProductSaga_BETA,

    ...notificationSaga,
    ...supportSaga,
    ...noticeSaga,

    /* TODO: remove referral-promotion */
    ...inviteSaga,
  ])
}

export type IRootState = StateType<typeof rootReducer>
